/**
 * Shared constants for all Order pages (orderByStore, orderBySku, orderByKit).
 *
 * Variant-specific constants (PREFIX, COL_CONFIG, GROUP_OPTIONS, EXCLUDED_GRID_FIELDS,
 * DEFAULT_EXPORT_FILENAME, entity-specific keywords) remain in each variant's constants.ts.
 */

/* ─── Master Data Table IDs ─── */
export const STORES_TABLE_ID = 20;
export const SKUS_TABLE_ID = 18;
export const WAREHOUSES_TABLE_ID = 102;

/* ─── Order Status Filter Options ─── */
export const ORDER_STATUS_PARAMS = [
	{ displayName: 'Cancelled', value: '1' },
	{ displayName: 'Completed', value: '2' },
	{ displayName: 'Open', value: '3' },
] as const;

/* ─── Columns Excluded from Filter Lists (internal/system columns) ─── */
export const EXCLUDED_FILTER_COLUMNS = [
	'CreatedBy',
	'ModifiedBy',
	'CreatedDate',
	'ModifiedDate',
	'IsActive',
	'IsDeleted',
	'ID',
	'RowID',
	'TableID',
] as const;

/* ─── Column Classification Keywords (used by sagas to classify columns) ─── */
export const COLUMN_EXCLUDE_KW = [
	'fiscal',
	'shipped',
	'sales',
	'comp',
	'margin',
	'sell thru',
	'asp',
	'planogram',
	'ship method',
	'fulfillment',
	'order qty',
	'orderqty',
	'projected',
	'available',
	'on order',
	'erpsku',
] as const;

export const COLUMN_WAREHOUSE_KW = ['warehouse'] as const;

export const COLUMN_STORE_KW = [
	'store',
	'customer',
	'district',
	'region',
	'city',
	'state',
	'postal',
	'address',
	'volume',
	'buyer',
	'area',
	'satt',
] as const;

export const COLUMN_ORDER_KW = [
	'generated date',
	'generateddate',
	'order batch',
	'orderbatch',
	'batch id',
	'batchid',
	'generated by',
	'generatedby',
	'order id',
	'orderid',
] as const;

/* ─── Progressive Loading Config ─── */
export const PAGE_SIZE = 5000;
export const MAX_BACKGROUND_PAGES = 20;

/* ─── Save / Debounce Timing ─── */
export const DEBOUNCE_SAVE_MS = 1000;
export const VALIDATION_ERROR_DISPLAY_MS = 3000;
export const AVAILABILITY_CAP_ERROR_MS = 2000;
export const BULK_ITEMS_PER_PAGE = 50;

/* ─── Field Names ─── */
export const SELECT_ROW_KEY = 'OrderDetailID';

/* ─── AG Grid Theme / Dimensions ─── */
export const GRID_HEADER_HEIGHT = 32;
export const GRID_ROW_HEIGHT = 28;
export const GRID_FONT_SIZE = 12;
export const GRID_MIN_COL_WIDTH = 50;
